<script setup lang="ts">
import { watch } from 'vue'
import { useGroupMain } from '@/entities/Group/Main'
import { useObjectHeader } from '@/widgets/ObjectHeader/model/model.ts'
import { VIcons } from '@/shared/ui'

const store = useGroupMain()
const { getBreadcrumbs } = useObjectHeader()

store.loadGroupMainData()

/**
 * Генерируем событие успешной загрузки данных
 * для использования в родительском компоненте
 */
const emits = defineEmits(['loadData'])

watch(
  () => store.group,
  () => {
    emits('loadData', store.group)
  },
)
</script>

<template>
  <div class="w-object-header" v-if="store.group">
    <div class="w-object-header__info">
      <VBreadcrumbs :items="getBreadcrumbs(store.group, 'stack')">
        <template v-slot:item="{ item }">
          <RouterLink class="v-breadcrumbs-item--link" :to="item.to" v-if="item.to">
            {{ item.title }}
          </RouterLink>
<!-- 
          <div class="v-breadcrumbs-item v-breadcrumbs-item--disabled" v-else>
            <VIcons class="w-content-header__icon" :type="item.icon" />
            {{ item.title }}
          </div> -->
        </template>
      </VBreadcrumbs>
    </div>
  </div>
</template>
